import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Impact sound insulation",
  description:
    "This principle section shows measurement results for impact sound insulation parameters for measurement situations shown below.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      colsSize: [1.5, 1],
      rowSpan: {
        "0:0": 2,
      },
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/22/principle/principle-8.png`,
                },
              },
              styles: {
                maxHeight: "562px",
                maxWidth: "429",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: `<b>Volume of the receiving room:</b> 31.3 m<sup>3</sup><br>
                  <b>Volume of the receiving room when<br>furniture volume is substructed:</b> 31.0 m<sup>3</sup><br>
                  <b>Surface of the floor:</b> 11.8 m<sup>2</sup>`,
                  scrollbars: false,
                  styles: {
                    fontSize: "12px",
                  },
                },
              },
              styles: {
                alignItems: "flex-end",
                justifyContent: "flex-start",
                paddingTop: "2%",
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "Measurement situation with source<br>positions in the  transmitting room<br>and transmsision paths  through<br>considered floor are shown.",
                  scrollbars: false,
                  styles: {
                    fontSize: "12px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                justifyContent: "flex-start",
                paddingTop: "2%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
